import React from 'react';

const PublicHolidaysHeader = () => {
  return (
    <div style={{ display: 'flex', width: '100%', gap: 8, padding: "16px 16px 16px 8px", borderBottom: '0.5px solid #407FDD' }}>
      {/* {!showInput && (
        <div style={{ width: '16%', fontWeight: 500, fontSize: 18 }}>Add</div>
      )} */}
      <div
        style={{
          width: '12.3%',
          fontWeight: 600,
          fontSize: 14,
          color: '#000000',
        }}
      >
        Month
      </div>
      <div
        style={{
          width: '12%',
          fontWeight: 600,
          fontSize: 14,
          color: '#000000',
        }}
      >
        Day
      </div>
      <div
        style={{
          width: '12%',
          fontWeight: 600,
          fontSize: 14,
          color: '#000000',
        }}
      >
        Period
      </div>
      <div
        style={{
          width: '12%',
          fontWeight: 600,
          fontSize: 14,
          color: '#000000',
        }}
      >
        Gender
      </div>
      <div
        style={{
          width: '12.3%',
          fontWeight: 600,
          fontSize: 14,
          color: '#000000',
        }}
      >
        Description
      </div>
      <div style={{ width: '37.5%' }} />
    </div>
  );
};

export default PublicHolidaysHeader;
